import { JSX } from "react";
import { useTranslation } from "react-i18next";

import NoData from "@/components/NoData";
import Button from "@/components/buttons/Button";
import Icon from "@/components/common/Icon/Icon";
import { MODAL_ROUTES } from "@/components/modals/router/ModalRoutes";
import BackButton from "@/components/staff/BackButton.tsx";
import OrderMovieList from "@/components/staff/order-movie/OrderMovieList.tsx";
import OrderMovieTable from "@/components/staff/order-movie/OrderMovieTable.tsx";

import { useGetMovieOrders } from "@/hooks/api/user.hooks";
import useModalRouter from "@/hooks/useModalRouter";

const StaffOrderMoviePage = (): JSX.Element => {
  const { t } = useTranslation();

  const { data: orders } = useGetMovieOrders();
  const { openModal } = useModalRouter();

  return (
    <section className={"staff-section-container"}>
      <div className={"max-lg:space-y-[1.875rem]"}>
        <BackButton />
        <div className={"flex items-center justify-between"}>
          <h1 className={"staff-section-title"}>{t("Orders.movie")}</h1>
          <Button
            color={"black"}
            size={"medium"}
            icon={<Icon name={"plus"} className={"size-6 stroke-on-primary"} />}
            className={"max-w-80 !py-3 max-xl:w-fit max-xl:p-3"}
            onClick={() => openModal(MODAL_ROUTES.ORDER_MOVIE)}
          >
            <span className={"max-xl:hidden"}>{t("Orders.movie")}</span>
          </Button>
        </div>
      </div>
      {orders.results.length ? (
        <>
          <OrderMovieTable className={"max-xl:hidden max-lg:block max-md:hidden"} orders={orders.results} />
          <div className={"hidden max-xl:block max-lg:hidden max-md:block max-sm:!mt-0"}>
            <hr className={"h-px w-full border-surface-container max-sm:hidden"} />
            <div className={"divide-surface-container max-sm:my-[0.375rem] sm:divide-y"}>
              {orders.results.map((order) => (
                <div className={"py-4 max-sm:py-[0.375rem]"} key={order.id}>
                  <OrderMovieList order={order} />
                </div>
              ))}
            </div>
            <hr className={"h-px w-full border-surface-container max-sm:hidden"} />
          </div>
        </>
      ) : (
        <NoData />
      )}
    </section>
  );
};

export default StaffOrderMoviePage;
